export interface IDynamicObject {
    header: string;         
    datatype: string;       
    value: any;             
  }

  export interface SalesReceiptRequestModel {
    ids: any[];
    channelId: number;
    isActive: boolean;
    globalSearchValue: string;
    selectableColumns: any[];
    filter: string;
    pageSize: number;
    pageNumber: number;
    sortByColumn: string;
    SearchColumns?: any;
    SearchValue?: any;
    sortByColumnDataType: string | null;
    isSortByDescending: boolean | null;
    filterInColumns: any[];
    excludeDefaultColumns: boolean;
    IncludeAllCustomAttributes: boolean;
  }
  
  export interface SalesReceiptGroupRequestModel extends SalesReceiptRequestModel {
    groupByColumnDataType: string;
    groupByColumnName: string;
    isGroupByColumnCSV: boolean;
    pageSize: number; 
    pageNumber: number; 
    rootPageSize: number;
    rootPageNumber: number;
    rootSortByColumnName: string;
    isRootSortByDescending: boolean;
    timezone: string | null;
  }
  
  export const STATUS_TYPES:any[] = [
  { id: 1, name: 'Created' },
  { id: 2, name: 'Voided' }
];

export namespace SalesReceiptFilterNS {
    export interface SalesReceiptFilterInColumn {
      name: string;
      value?: string;
      operator: string;
      operationType?: string;
      values?: string[];
      isCustom?: boolean;
      fieldId?: number;
      filterValues?: { id: number; value: string }[];
    }
  
    export type SalesReceiptDataTypes = 'String' | 'Number' | 'Decimal' | 'Boolean' | 'DateTime' | 'Time' | 'Enum' | 'Distance' | 'Money';
    export type SalesReceiptValueDataTypes = 'String' | 'Number' | 'Decimal' | 'Boolean' | 'DateTime' | 'Time' | 'Enum' | 'User' | 'Country' | 'DropdownList' | 'MultiSelect' | 'MultiSelectAPI' | 'Year' | 'TreeSelect' | 'Distance' | 'AutoCompleteDropdown' | 'Rating' | 'Money';
    export type SalesReceiptNoOfValuesToBePassed = 'No_Value' | 'Single_Value' | 'Between_Value' | 'Multiple';
    export type SalesReceiptOperator =
      | 'IsEqualTo' | 'IsNotEqualTo' | 'StartsWith' | 'EndsWith' | 'Contains' | 'DoesNotContain'
      | 'HasValue' | 'NoValue' | 'On' | 'NotOn' | 'Between' | 'NotBetween' | 'Before' | 'After'
      | 'OnOrBefore' | 'OnOrAfter' | 'IsGreaterThan' | 'IsLessThan' | 'IsGreaterThanEqualTo'
      | 'IsLessThanEqualTo' | 'Within' | 'Outside';
  
    export interface ISalesReceiptFilterDataTypeWithOperator {
      DataType: SalesReceiptDataTypes;
      Operator: SalesReceiptOperator;
      NoOfValuesToBePassed: SalesReceiptNoOfValuesToBePassed;
    }
  
    export const SalesReceiptFilterDataTypeWithOperator: ISalesReceiptFilterDataTypeWithOperator[] = [
      { DataType: 'Boolean', Operator: 'IsEqualTo', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'Boolean', Operator: 'IsNotEqualTo', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'DateTime', Operator: 'On', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'DateTime', Operator: 'NotOn', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'DateTime', Operator: 'Between', NoOfValuesToBePassed: 'Between_Value' },
      { DataType: 'DateTime', Operator: 'Before', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'DateTime', Operator: 'After', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'DateTime', Operator: 'OnOrBefore', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'DateTime', Operator: 'OnOrAfter', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'Time', Operator: 'On', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'Time', Operator: 'NotOn', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'Time', Operator: 'Between', NoOfValuesToBePassed: 'Between_Value' },
      { DataType: 'Time', Operator: 'NotBetween', NoOfValuesToBePassed: 'Between_Value' },
      { DataType: 'Time', Operator: 'Before', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'Time', Operator: 'After', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'Time', Operator: 'OnOrBefore', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'Time', Operator: 'OnOrAfter', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'Number', Operator: 'IsEqualTo', NoOfValuesToBePassed: 'Multiple' },
      { DataType: 'Number', Operator: 'IsNotEqualTo', NoOfValuesToBePassed: 'Multiple' },
      { DataType: 'Number', Operator: 'StartsWith', NoOfValuesToBePassed: 'Multiple' },
      { DataType: 'Number', Operator: 'EndsWith', NoOfValuesToBePassed: 'Multiple' },
      { DataType: 'Number', Operator: 'Contains', NoOfValuesToBePassed: 'Multiple' },
      { DataType: 'Number', Operator: 'DoesNotContain', NoOfValuesToBePassed: 'Multiple' },
      { DataType: 'Number', Operator: 'Between', NoOfValuesToBePassed: 'Between_Value' },
      { DataType: 'Number', Operator: 'NotBetween', NoOfValuesToBePassed: 'Between_Value' },
      { DataType: 'Number', Operator: 'IsGreaterThan', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'Number', Operator: 'IsLessThan', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'Number', Operator: 'IsGreaterThanEqualTo', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'Number', Operator: 'IsLessThanEqualTo', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'Decimal', Operator: 'IsEqualTo', NoOfValuesToBePassed: 'Multiple' },
      { DataType: 'Decimal', Operator: 'IsNotEqualTo', NoOfValuesToBePassed: 'Multiple' },
      { DataType: 'Decimal', Operator: 'Between', NoOfValuesToBePassed: 'Between_Value' },
      { DataType: 'Decimal', Operator: 'NotBetween', NoOfValuesToBePassed: 'Between_Value' },
      { DataType: 'Decimal', Operator: 'IsGreaterThan', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'Decimal', Operator: 'IsLessThan', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'Decimal', Operator: 'IsGreaterThanEqualTo', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'Decimal', Operator: 'IsLessThanEqualTo', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'Money', Operator: 'IsEqualTo', NoOfValuesToBePassed: 'Multiple' },
      { DataType: 'Money', Operator: 'IsNotEqualTo', NoOfValuesToBePassed: 'Multiple' },
      { DataType: 'Money', Operator: 'Between', NoOfValuesToBePassed: 'Between_Value' },
      { DataType: 'Money', Operator: 'NotBetween', NoOfValuesToBePassed: 'Between_Value' },
      { DataType: 'Money', Operator: 'IsGreaterThan', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'Money', Operator: 'IsLessThan', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'Money', Operator: 'IsGreaterThanEqualTo', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'Money', Operator: 'IsLessThanEqualTo', NoOfValuesToBePassed: 'Single_Value' },
      { DataType: 'String', Operator: 'IsEqualTo', NoOfValuesToBePassed: 'Multiple' },
      { DataType: 'String', Operator: 'IsNotEqualTo', NoOfValuesToBePassed: 'Multiple' },
      { DataType: 'String', Operator: 'StartsWith', NoOfValuesToBePassed: 'Multiple' },
      { DataType: 'String', Operator: 'EndsWith', NoOfValuesToBePassed: 'Multiple' },
      { DataType: 'String', Operator: 'Contains', NoOfValuesToBePassed: 'Multiple' },
      { DataType: 'String', Operator: 'DoesNotContain', NoOfValuesToBePassed: 'Multiple' },
      { DataType: 'String', Operator: 'HasValue', NoOfValuesToBePassed: 'No_Value' },
      { DataType: 'String', Operator: 'NoValue', NoOfValuesToBePassed: 'No_Value' },
      { DataType: 'Enum', Operator: 'IsEqualTo', NoOfValuesToBePassed: 'Multiple' },
      { DataType: 'Enum', Operator: 'IsNotEqualTo', NoOfValuesToBePassed: 'Multiple' },
      { DataType: 'Enum', Operator: 'HasValue', NoOfValuesToBePassed: 'No_Value' },
      { DataType: 'Enum', Operator: 'NoValue', NoOfValuesToBePassed: 'No_Value' },
      { DataType: 'Distance', Operator: 'Within', NoOfValuesToBePassed: 'Multiple' },
      { DataType: 'Distance', Operator: 'Outside', NoOfValuesToBePassed: 'Multiple' },
    ];
  }